var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddressCard',{staticClass:"ma-5"}),_c('DeliveryAddress',{staticClass:"ma-5"}),_c('Checkout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }